module.exports = __webpack_public_path__ + "static/media/nossa-cria.9c76aadc.jpg";